import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { of, Observable, Subject } from 'rxjs';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { DocumentReader, FilterGroup, Filter, RuleOperator, FilterGroupType } from 'src/app/modules/core/store/models';
import { DataApiService } from 'src/app/modules/management/store/data/data-api.service';

@Component({
  selector: 'app-reference-column',
  templateUrl: './reference-column.component.html',
  styleUrls: ['./reference-column.component.scss'],
  standalone: false
})
export class ReferenceColumnComponent implements OnInit, OnDestroy, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  valueForDisplay: string;
  selectedDocumentId: string;
  filterFields: string;
  destroy$ = new Subject<void>();

  constructor(private dataApiService: DataApiService) {}

  ngOnInit(): void {
    this.valueForDisplay = this.document?.[this.field.systemName + '_display'];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get fieldValue(): string {
    return this.valueForDisplay;
  }

  getDisplyString(document: Document): string {
    const reader: DocumentReader = new DocumentReader(document);

    const filterFields = this.filterFields.split(',');
    const values = [];

    filterFields.map(f => values.push(reader.getFieldValue(f)));
    return values.join(', ');
  }

  getReferenceObject(documentId: string): void {
    this.getReferenceObjectById(documentId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(documents => {
        const selectedDocument: Document = documents?.length > 0 ? documents[0] : null;
        this.valueForDisplay = this.getDisplyString(selectedDocument);
      });
  }

  getReferenceObjectById(documentId: string = null): Observable<Document[]> {
    const filter: Filter = {
      field: 'uid',
      operator: RuleOperator.Equal,
      value: documentId
    };

    const filterGroup: FilterGroup = {
      uId: null,
      filters: [filter],
      filterGroups: null,
      groupType: FilterGroupType.And
    };

    return this.dataApiService
      .getDocuments(this.field.settings.relatedDatasetUId, {
        pagination: {
          skip: 0,
          take: 1
        },
        fields: 'uid,' + this.filterFields,
        filterGroup: filterGroup
      })
      .pipe(
        catchError(e => {
          console.error(e);
          return of({ data: [] });
        }),
        map(({ data }) => {
          return data;
        })
      );
  }
}
